import { Box } from "@chakra-ui/react";
import React, {
  forwardRef,
  ReactElement,
  ReactNode,
  ForwardedRef,
} from "react";

export interface FullScreenProps {
  zIndex?: number;
  pointerEvents?: "all" | "none";
  children?: ReactNode;
}

function FullScreen(
  props: FullScreenProps,
  ref: ForwardedRef<HTMLDivElement>
): ReactElement {
  const { zIndex, pointerEvents, children } = props;

  return (
    <Box
      ref={ref}
      position="absolute"
      top="0"
      bottom="0"
      left="0"
      right="0"
      zIndex={zIndex}
      pointerEvents={pointerEvents}
    >
      {children}
    </Box>
  );
}

export default forwardRef(FullScreen);
